import React from 'react';

import { CustomAvatar } from '@europrocurement/flexy-components/components/molecules';
import { Typography } from '@mui/material';
import { Box, lighten, SxProps, useTheme } from '@mui/system';

export type ContactWidgetProps = {
    prenomContact?: string;
    nomContact?: string;
    userIdentifier?: string;
    telephonesContact?: Array<{
        telephone: string;
    }>;
    emailsContact?: Array<{
        email: string;
    }>;
    sx?: SxProps;
    onClick?: () => void;
};

export const ContactWidget: React.FunctionComponent<ContactWidgetProps> = function ({
    prenomContact = '',
    nomContact = '',
    userIdentifier = undefined,
    telephonesContact = [],
    emailsContact = [],
    sx = {},
    onClick = () => {},
}) {
    const theme = useTheme();

    return (
        <Box
            onClick={onClick}
            sx={{
                borderRadius: '15px',
                minHeight: '75px',
                backgroundColor: 'background.paper',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: theme.palette.divider,
                display: 'flex',
                flexDirection: 'row',
                boxSizing: 'border-box',
                transition: 'background-color ease-in-out 150ms, border-color ease-in-out 150ms',
                ':hover': {
                    backgroundColor: lighten(theme.palette.primary.main, 0.95),
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: theme.palette.primary.main,
                    cursor: 'pointer',
                    '& > div:last-child': {
                        opacity: 1,
                    },
                },
                ...sx,
            }}
        >
            <Box
                sx={{
                    width: '75px',
                    height: '75px',
                }}
            >
                <CustomAvatar
                    firstName={prenomContact}
                    lastName={nomContact}
                    sx={{
                        width: 55,
                        height: 55,
                        margin: '10px 20px 10px 5px',
                    }}
                    keycloakId={userIdentifier || undefined}
                />
            </Box>
            <Box
                sx={{
                    marginTop: '8px',
                    width: 'calc(100% - 75px)',
                }}
                display="flex"
                alignItems="flex-start"
                flexDirection="column"
            >
                <Typography
                    variant="l2dbodys"
                    sx={{
                        fontWeight: '600',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        ':hover': { overflow: 'visible' },
                        maxWidth: '100%',
                    }}
                >
                    {prenomContact} {nomContact}
                </Typography>
                {emailsContact[0] ? (
                    <Typography
                        sx={{
                            fontSize: '0.75rem',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            ':hover': { overflow: 'visible' },
                            maxWidth: '100%',
                            lineHeight: '1.15rem',
                        }}
                        color="text.secondary"
                    >
                        {emailsContact[0].email}
                    </Typography>
                ) : null}
                {telephonesContact[0] ? (
                    <Typography
                        sx={{
                            fontSize: '0.75rem',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            ':hover': { overflow: 'visible' },
                            maxWidth: '100%',
                            lineHeight: '1.15rem',
                        }}
                        color="text.secondary"
                    >
                        {telephonesContact[0].telephone}
                    </Typography>
                ) : null}
            </Box>
        </Box>
    );
};
